import { render, staticRenderFns } from "./DialogSendContact.vue?vue&type=template&id=583bef84&scoped=true&"
import script from "./DialogSendContact.vue?vue&type=script&lang=ts&"
export * from "./DialogSendContact.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSendContact.vue?vue&type=style&index=0&id=583bef84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583bef84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VSpacer,VTab,VTabItem,VTabs})
